import { Controller } from '@hotwired/stimulus';

export class CloudflareTurnstileController extends Controller {
  static values = {
    siteKey: String,
  };

  connect() {
    this.ensureTurnstileLoaded().then(() => {
      this.renderWidget();
    }).catch(error => {
      console.error('Error loading Turnstile', error);
    });
  }

  disconnect() {
    if (this.widgetId && window.turnstile?.reset) {
      window.turnstile.reset(this.widgetId);
      this.widgetId = null;
    }
  }

  ensureTurnstileLoaded() {
    return new Promise((resolve, reject) => {
      if (window.turnstile) return resolve();

      const existingScript = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve());
        existingScript.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  renderWidget() {
    if (this.element.dataset.turnstileRendered === 'true') return;

    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.siteKeyValue,
      appearance: 'interaction-only',
      size: 'flexible',
      theme: 'light',
    });

    this.element.dataset.turnstileRendered = 'true';
  }
}
